var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDatabase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 33,
    viewBox: "0 0 30 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-database",
    "data-name": "Icon feather-database",
    transform: "translate(-3 -1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M31.5,7.5C31.5,9.985,25.456,12,18,12S4.5,9.985,4.5,7.5,10.544,3,18,3,31.5,5.015,31.5,7.5Z",
    fill: "none",
    stroke: "#7352ed",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M31.5,18c0,2.49-6,4.5-13.5,4.5S4.5,20.49,4.5,18",
    fill: "none",
    stroke: "#7352ed",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M4.5,7.5v21c0,2.49,6,4.5,13.5,4.5s13.5-2.01,13.5-4.5V7.5",
    fill: "none",
    stroke: "#7352ed",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabase);
export default __webpack_public_path__ + "static/media/database.59bae8b9212de477864c71df27c7b846.svg";
export { ForwardRef as ReactComponent };